module.exports = __webpack_public_path__ + "static/img/zfb.ed829c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zfb.png
// module id = Zx4y
// module chunks = 1